<template>
  <div class="container">
    <div class="row">
      <div id="column-left" class="col-sm-3 hidden-xs column-left">
        <div class="banner">
          <div class="item">
            <a href="#"
              ><img
                src="../assets/image/banners/LeftBanner.jpg"
                alt="Left Banner"
                class="img-responsive"
                style="width:100%"
            /></a>
          </div>
        </div>

        <div id="most-popular-category"></div>
      </div>
      <div id="content" class="col-sm-9">
        <h2 class="category-title">{{ categoryType }}</h2>
        <div class="row category-banner">
          <div class="col-sm-12 category-image">
            <img
              src="../assets/image/banners/category-banner.jpg"
              alt="Desktops"
              title="Desktops"
              class="img-thumbnail"
            />
          </div>
          <div class="col-sm-12 category-desc">
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum."
          </div>
        </div>
        <div class="category-page-wrapper">
          <div class="col-md-6 list-grid-wrapper">
            <div class="btn-group btn-list-grid">
              <button
                type="button"
                id="list-view"
                class="btn btn-default list"
                data-toggle="tooltip"
                title="List"
              >
                <i class="fa fa-th-list"></i>
              </button>
              <button
                type="button"
                id="grid-view"
                class="btn btn-default grid active"
                data-toggle="tooltip"
                title="Grid"
              >
                <i class="fa fa-th"></i>
              </button>
            </div>
            <a href="#" id="compare-total">Product Compare (0)</a>
          </div>
          <div class="col-md-1 text-right page-wrapper">
            <label class="control-label" for="input-limit">Show:</label>
            <div class="limit">
              <select id="input-limit" class="form-control">
                <option value="8" selected="selected">8</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="75">75</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
          <div class="col-md-2 text-right sort-wrapper">
            <label class="control-label" for="input-sort">Sort By:</label>
            <div class="sort-inner">
              <select id="input-sort" class="form-control">
                <option value="ASC" selected="selected">Default</option>
                <option value="ASC">Name (A - Z)</option>
                <option value="DESC">Name (Z - A)</option>
                <option value="ASC">Price (Low &gt; High)</option>
                <option value="DESC">Price (High &gt; Low)</option>
                <option value="DESC">Rating (Highest)</option>
                <option value="ASC">Rating (Lowest)</option>
                <option value="ASC">Model (A - Z)</option>
                <option value="DESC">Model (Z - A)</option>
              </select>
            </div>
          </div>
        </div>
        <br />
        <div class="grid-list-wrapper">
          <div
            class="product-layout product-grid col-lg-3 col-md-4 col-sm-6 col-xs-12"
            v-for="(product, index) in getListProducts()"
            :key="index"
          >
            <div class="product-thumb">
              <div class="image product-imageblock flex items-center">
                <a :href="'#/product/' + product.id">
                  <img
                    :src="product.image"
                    :alt="product.name"
                    :title="product.name"
                    class="img-responsive"
                  />
                </a>
                <div class="button-group" style="display:none;">
                  <button type="button" class="addtocart-btn">
                    Add to Cart
                  </button>
                </div>
              </div>
              <div class="caption product-detail">
                <h4 class="product-name">
                  <a :href="'#/product/' + product.id" :title="product.name">
                    {{ $options.filters.limit(product.name, 53) }}
                  </a>
                </h4>
                <p class="product-desc">{{ product.desc }}</p>
                <p class="price product-price">
                  <span class="price-old" v-if="product.oldPrice"
                    >${{ product.oldPrice }}</span
                  >
                  ${{ product.price }}
                  <span class="price-tax">Ex Tax: $100.00</span>
                </p>
              </div>
              <div class="button-group">
                <button
                  type="button"
                  class="wishlist"
                  data-toggle="tooltip"
                  title="Add to Wish List"
                >
                  <i class="fa fa-heart-o"></i>
                </button>
                <button type="button" class="addtocart-btn">Add to Cart</button>
                <button
                  type="button"
                  class="compare"
                  data-toggle="tooltip"
                  title="Compare this Product"
                >
                  <i class="fa fa-exchange"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import productData from "../data/product.json";

export default {
  data() {
    return {
      basketData: JSON.parse(localStorage.getItem("basket")) || [],
      categoryType: this.$route.params.type,
      deviceId: ""
    };
  },
  methods: {
    getListProducts() {
      return productData.product.filter(p => p.category == this.categoryType);
    },
    getTypeId() {
      if (this.categoryType == 'electronics') {
        return 1;
      } else if (this.categoryType == 'mobile') {
        return 2;
      } else if (this.categoryType == 'fashion') {
        return 3;
      } else if (this.categoryType == 'games') {
        return 4;
      } else if (this.categoryType == 'sports') {
        return 5;
      } 
    }
  },
  created() {
    var $this = this;

    dengage("getContactKey", function(contact_key) {
      window.sgfLayer = {
        page: {
          pageUrl: "https://muhammed-wh.github.io/#/category/",
          category: "Category Page",
          subCategory: $this.categoryType
        }
      };
      if (contact_key) {
        window.sgfLayer.common = {
          userId: contact_key
        };
      } else {
        dengage("getDeviceId", function(device_id) {
          window.sgfLayer.common = {
            userId: device_id
          };
        });
      }
    });

    /*dengage("sendDeviceEvent", "user_events", {
      event_type: "page_view",
      page_url: window.location.href,
      page_type: "category",
      page_title: this.categoryType
    });*/
    var a = {
      pageName: "category-page",
      pageType: "category",
      category: this.categoryType,
      page_title: this.categoryType
    }
    dataLayer.push(a);
    /*dataLayer.push({
      event: 'dengage_event',
      dengage_table_name: 'user_events',
      dengage_event_data: {
        event_type: "page_view",
        page_url: window.location.href,
        page_type: "category",
        page_title: this.categoryType
      }
    });*/

    dengage("ec:pageView", {
      page_type: "category",
      category_id: this.getTypeId(),
      category_path: this.categoryType,
    });
    dengage('setNavigation', {name: 'category'});

    //collector.categoryPage(this.categoryType, 'main', localStorage.getItem('contact_key'))
  }
};
</script>

<style scoped>
.product-slider .product-thumb .product-imageblock,
#content .product-grid .product-thumb .product-imageblock,
#content .product-list .product-thumb .product-imageblock {
  width: 220px;
  height: 295px;
}
.product-thumb .image a {
  margin: 0 auto;
}
#content .product-grid .product-thumb .product-imageblock img,
#content .product-list .product-thumb .product-imageblock img {
  width: 135px;
  margin: 0 auto;
}
.product-thumb .product-name {
  min-height: 28px;
  max-height: 28px;
}
.product-list .product-thumb .caption {
  width: 72%;
}
</style>



// WEBPACK FOOTER //
// src/views/Category.vue